import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.find";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import { ElementType } from '../elements';
export var ParserHelper =
/*#__PURE__*/
function () {
  function ParserHelper() {
    _classCallCheck(this, ParserHelper);

    this.sdkResolvedAttributeName = 'data-sdk-resolved';
  }

  _createClass(ParserHelper, [{
    key: "getLinkedItem",
    value: function getLinkedItem(linkedItems, itemCodename) {
      if (!linkedItems) {
        return undefined;
      }

      return linkedItems.find(function (m) {
        return m.system.codename === itemCodename;
      });
    }
  }, {
    key: "tryGetImage",
    value: function tryGetImage(inputElement, linkedItems, imageId) {
      var elementImage = inputElement.images.find(function (m) {
        return m.imageId === imageId;
      });

      if (elementImage) {
        return elementImage;
      } // try to find image in all linked items


      if (linkedItems) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = linkedItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var linkedItem = _step.value;

            for (var _i = 0, _Object$keys = Object.keys(linkedItem.elements); _i < _Object$keys.length; _i++) {
              var elementKey = _Object$keys[_i];
              var element = linkedItem.elements[elementKey];

              if (element.type === ElementType.RichText) {
                var richTextElement = element;
                var richTextElementImage = richTextElement.images.find(function (m) {
                  return m.imageId === imageId;
                });

                if (richTextElementImage) {
                  return richTextElementImage;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
              _iterator["return"]();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      return undefined;
    }
  }, {
    key: "tryGetLink",
    value: function tryGetLink(inputElement, linkedItems, linkId) {
      var elementLink = inputElement.links.find(function (m) {
        return m.linkId === linkId;
      });

      if (elementLink) {
        return elementLink;
      } // try to find link in all linked items


      if (linkedItems) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = linkedItems[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var linkedItem = _step2.value;

            for (var _i2 = 0, _Object$keys2 = Object.keys(linkedItem.elements); _i2 < _Object$keys2.length; _i2++) {
              var elementKey = _Object$keys2[_i2];
              var element = linkedItem.elements[elementKey];

              if (element.type === ElementType.RichText) {
                var richTextElement = element;
                var richTextElementLink = richTextElement.links.find(function (m) {
                  return m.linkId === linkId;
                });

                if (richTextElementLink) {
                  return richTextElementLink;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
              _iterator2["return"]();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }

      return undefined;
    }
  }, {
    key: "convertToParserElement",
    value: function convertToParserElement(element) {
      var attributes = [];

      for (var i = 0; i < element.attributes.length; i++) {
        var attribute = element.attributes[i];
        attributes.push({
          name: attribute.name,
          value: attribute.value
        });
      }

      return {
        tag: element.tagName,
        setAttribute: function setAttribute(attributeName, attributeValue) {
          var attribute = element.attributes.getNamedItem(attributeName);

          if (attribute) {
            attribute.value = attributeValue !== null && attributeValue !== void 0 ? attributeValue : '';
          } else {
            element.setAttribute(attributeName, attributeValue !== null && attributeValue !== void 0 ? attributeValue : '');
          }
        },
        setInnerHtml: function setInnerHtml(newHtml) {
          return element.innerHTML = newHtml;
        },
        setOuterHtml: function setOuterHtml(newHtml) {
          return element.outerHTML = newHtml;
        },
        html: element.innerHTML,
        text: element.textContent ? element.textContent : undefined,
        attributes: attributes,
        parentElement: element.parentElement ? this.convertToParserElement(element.parentElement) : undefined,
        sourceElement: element
      };
    }
  }]);

  return ParserHelper;
}();
export var parserHelper = new ParserHelper();